// src/components/home/navIcons.js
//
// The icons of the home sidebar's items (src/config/homeShortcuts.js names
// them), shared by the sidebar and My quick links' pinned pages. lucide-react,
// already a dependency; nothing downloaded.

import {
  Activity, BarChart3, Bell, BookOpen, CalendarRange, ClipboardList, Contact, Database, FileStack, FileText, FileUp,
  LayoutGrid, Megaphone, MessageSquare, Microscope, Phone, Plus, Search, Send, ShieldCheck, Stethoscope, UserCog,
  UserPlus, Users,
} from "lucide-react";

export const NAV_ICONS = {
  Activity, BarChart3, Bell, BookOpen, CalendarRange, ClipboardList, Contact, Database, FileStack, FileText, FileUp,
  LayoutGrid, Megaphone, MessageSquare, Microscope, Phone, Plus, Search, Send, ShieldCheck, Stethoscope, UserCog,
  UserPlus, Users,
};

export const navIcon = (name) => NAV_ICONS[name] || LayoutGrid;
